module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ItemSearchSingleWrapper mx-auto mb-3",
    class: {
      disabled: _vm.disabled
    }
  }, [_c('div', {
    on: {
      "mouseover": function($event) {
        _vm.isHover = true;
      },
      "mouseleave": function($event) {
        _vm.isHover = false;
      }
    }
  }, [(_vm.isHover && !_vm.disabled) ? _c('div', {
    staticClass: "itemOverlay",
    on: {
      "click": function($event) {
        _vm.addItemHover();
      }
    }
  }, [_c('div', {
    staticClass: "itemOverlayInner d-flex align-items-center flex-column justify-content-center"
  }, [_c('p', [_vm._v("Add to forecast")]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [(_vm.isHover) ? _c('ForecastIcon', {
    staticClass: "icon",
    attrs: {
      "color": '#fff'
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "image-wrapper mx-auto"
  }, [_c('ItemImage', {
    staticClass: "item-image",
    attrs: {
      "item": _vm.item,
      "height": '120px',
      "width": '120px'
    }
  })], 1)])]), _vm._v(" "), _c('div', [_c('ItemDescription', {
    attrs: {
      "item": _vm.item,
      "is-link-to-item-detail": false,
      "isShowPriceDetails": true,
      "is-disabled": _vm.disabled,
      "forecastWindows": _vm.forecastWindows
    },
    on: {
      "clicked": _vm.addItem
    }
  }), _vm._v(" "), _c('br')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2892e3bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/sections/itemSearch/ItemSearchSingle.vue
// module id = 3090
// module chunks = 0